import React, { useState } from 'react';
import PracticeChecklist from './PracticeChecklist';
import usePractiveReview from '../../assets/helpers/usePractiveReview';
import NotCompletedResponse from './NotCompletedResponse';
import CompletionQuestionnaire from './CompletionQuestionnaire';
import ActivityBadge from '../shared/badges/ActivityBadge';
import { useBadge } from '../../customHooks/useBadge';
import module1 from '../../assets/course/practice-checklist/module-1';
import module2 from '../../assets/course/practice-checklist/module-2';
import module3 from '../../assets/course/practice-checklist/module-3';
import module4 from '../../assets/course/practice-checklist/module-4';
import module5 from '../../assets/course/practice-checklist/module-5';
import module6 from '../../assets/course/practice-checklist/module-6';
import './PractieChecklistWrapper.scss';

const moduleForms = {
  1: module1,
  2: module2,
  3: module3,
  4: module4,
  5: module5,
  6: module6,
};

export const PractieChecklistWrapper = ({ module, practiceBadge }) => {
  const [showChecklist, setShowChecklist] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [{ showBadge }, dispatch] = useBadge(false);
  const dataState = usePractiveReview(module);
  const formArr = moduleForms[module] || [];
  return (
    <section>
      {showChecklist !== 'YES' && (
        <section className='ready-to-complete'>
          {!showChecklist && !submitted && (
            <CompletionQuestionnaire
              modNum={module}
              confirmAction={() => setShowChecklist('YES')}
              denyAction={() => setShowChecklist('NO')}
              completed={dataState}
            />
          )}
          {submitted && (
            <p className='submission-response'>
              Great work! Keep putting what you learned into action to get the
              results you want!
            </p>
          )}
          {showChecklist === 'NO' && !submitted && <NotCompletedResponse />}
        </section>
      )}
      {showChecklist === 'YES' && !submitted && (
        <PracticeChecklist
          module={module}
          formArr={formArr}
          submitButton={'Submit'}
          setSubmitted={() => {
            dispatch({ type: 'show', payload: practiceBadge });
            setSubmitted(true);
            setShowChecklist(false);
          }}
        />
      )}
      <ActivityBadge
        showBadge={showBadge}
        dispatch={dispatch}
        content={practiceBadge}
      />
    </section>
  );
};
